'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _KEYS;

exports["default"] = isNavigationKey;

var _constants = require('../../../libs/constants');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var KEYS = (_KEYS = {}, _defineProperty(_KEYS, _constants.UP_KEY, true), _defineProperty(_KEYS, _constants.DOWN_KEY, true), _defineProperty(_KEYS, _constants.ENTER_KEY, true), _KEYS);

function isNavigationKey(keyCode) {
  return !!KEYS[keyCode];
}